import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, tap, of, lastValueFrom } from 'rxjs';
import { PaginationLimit } from 'src/app/core/constants/dropdown-contants';
import { UsersService } from 'src/app/core/services/users/users.service';

@Injectable({
  providedIn: 'root'
})
export class CacheUserService {

  private userListSubject = new BehaviorSubject<any>([]);
  public userList$ = this.userListSubject.asObservable();
  totaluserCount: number = 0;

  constructor(private _usersService: UsersService) { }
  previousPagination = {
    skip: 0,
    limit: PaginationLimit.user
  };
  previousFilter: string = ''
  async fetchusers(pagination: any, filter: string = '', userType?: string): Promise<{ data: any[], total: number }> {
    // If pagination updates, force a new API call regardless of cached data
    if (this.previousPagination?.skip !== pagination.skip || this.previousPagination?.limit !== pagination.limit || this.previousFilter !== filter) {
      // Save the new pagination state
      this.previousPagination = { ...pagination };
      this.previousFilter = filter;
      this.userListSubject.next([])
    } else {
      // Return cached data if pagination has not changed
      if (this.userListSubject.value.length > 0) {
        return { data: this.userListSubject.value, total: this.totaluserCount };
      }
    }

    try {
      // Fetch data from the service
      const res =
        userType === 'caseowner' ? await lastValueFrom(this._usersService.getCaseOwnerV3(pagination,'')) : await lastValueFrom(this._usersService.getUsersList(pagination, userType, '', filter));

      // If the response is successful and contains data
      if (res?.statusCode === 200 && res?.data?.data?.length > 0) {
        const userList = res.data.data;
        const total = res.data.total;

        // Store the fetched data in the subject to cache it
        this.userListSubject.next(userList);

        // Store total count
        this.totaluserCount = total;

        // Return both data and total
        return { data: userList, total };
      } else {
        // Return an empty array and 0 total if no data found
        return { data: [], total: 0 };
      }
    } catch (error) {
      // Handle any errors during the API call
      console.error('Error fetching universities:', error);
      return { data: [], total: 0 };
    }
  }



  getuserById(userId: string): Observable<any> {
    const existinguser = this.userListSubject.value.find(u => u.id === userId);
    if (existinguser) {
      return of(existinguser);
    }

    return this._usersService.getUserById(userId).pipe(
      tap((res: any) => {
        if (res?.data) {
          const user = { id: res.data.id, name: res.data.name };
          const updatedList = [...this.userListSubject.value, user];
          this.userListSubject.next(updatedList);
        }
      })
    );
  }
}
